const Project = ({ title, image, url, onProjectClick }) => {
  // This helper function stops the page from refreshing
  // and triggers your internal page swap if it exists.
  const handleClick = (e) => {
    if (onProjectClick) {
      e.preventDefault();
      onProjectClick();
    }
  };

  return (
    <div className='row'>
      <div className='col s12 m7'>
        <div className='card hoverable'>
          <div className='card-image'>
            {/* If onProjectClick is provided, it uses the handler; otherwise it uses the URL */}
            <a href={url || '#'} onClick={handleClick}>
              <img src={image} alt={title} />
            </a>
          </div>
          <div className='card-action'>
            {/* target='_blank' only applies to external links (when no onProjectClick exists) */}
            <a
              href={url || '#'}
              target={onProjectClick ? '_self' : '_blank'}
              rel='noreferrer'
              onClick={handleClick}
            >
              {title}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;

// const Project = ({ title, image, url }) => {
//   return (
//     <div className='row'>
//       <div className='col s12 m7'>
//         <div className='card'>
//           <div className='card-image'>
//             <a href={url}>
//               <img src={image}></img>
//             </a>
//           </div>
//           {/* <div className='card-content'>
//             <p>
//               I am a very simple card. I am good at containing small bits of
//               information. I am convenient because I require little markup to
//               use effectively.
//             </p>
//           </div> */}
//           <div className='card-action'>
//             <a href={url} target='_blank'>
//               {title}
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Project;
